<template>
  <div class="page page-full">
    <div class="page-header with-actions">
      <h1>Client Notifications</h1>
      <div class="actions">
        <b-btn @click="showClientNotificationCreate" variant="success">Add New Client Notification</b-btn>
      </div>
    </div>
    <dt-datatable ref="clientNotificationList" :id="tableId" url="/client-notification/list" :columns="columns" :dt-options="dtOptions">
      <template #actions="{ data: clientNotification }">
        <div class="td-links-wrap">
          <a class="btn btn-link p-0 mr-2 text-success" @click="deleteClientNotification(clientNotification.id)">Delete</a>
          <a class="btn btn-link p-0 text-success" @click="showClientNotificationEdit(clientNotification.id)">Edit</a>
        </div>
      </template>
    </dt-datatable>
    <create-modal ref="createClientNotificationModal" @success="clientNotificationSaved" />
  </div>
</template>

<script>
  import CreateModal from './create-edit-client-notification-modal.vue';

  import clientNotificationService from 'services/client-notification-service';

  export default {
    components: {
      CreateModal
    },

    data() {
      return {
        tableId: "client-notification-list",
        columns: [
          { name: "ClientId" },
          { name: "Email" },
          { name: "Actions", data: false }
        ],
        dtOptions: {}
      }
    },

    methods: {
      async deleteClientNotification(id) {
        this.$root.successToast("Client notification deleted!");
        await clientNotificationService.delete(id);
        this.redrawTable();
      },

      clientNotificationSaved() {
        this.$root.successToast("Client notification created!");
        this.redrawTable();
      },

      showClientNotificationCreate() {
        this.$refs.createClientNotificationModal.show();
      },

      showClientNotificationEdit(id) {
        this.$refs.createClientNotificationModal.show(id);
      },

      redrawTable() {
        this.$refs.clientNotificationList.draw();
      }
    }
  }
</script>